import { AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessage } from "../../services/axios";
import { RESPONSEBASE } from "../../services/services-model.type";

import { fetchConfigSuccess, fetchConfigFailure } from "./actions";
import { FETCH_CONFIG_REQUEST } from "./actions.type";
import { getConfigRequest } from "./service";

function* fetchConfigSaga() {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(getConfigRequest);
    console.log("fetchConfigSaga response: ", response);
    if (response.status === 200) {
      yield put(fetchConfigSuccess());
    }
  } catch (e) {
    console.log("e: ", e);
    yield put(fetchConfigFailure());
    getErrorMessage(e, false);
  }
}

function* configSaga() {
  yield all([takeLatest(FETCH_CONFIG_REQUEST, fetchConfigSaga)]);
}

export default configSaga;
